// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-NavBar-module__navBar-awooG,
.nightbot-NavBar-module__actionButton-cgQw8 {
  flex: 1;
}

.nightbot-NavBar-module__actionButton-cgQw8 {
  display: flex;
  justify-content: right;
}

.nightbot-NavBar-module__navLinks-tYulX {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 32px;
  justify-content: center;
}

.nightbot-NavBar-module__navLinks-tYulX a,.nightbot-NavBar-module__navLinks-tYulX button {
    color: var(--text-secondary);
  }

.nightbot-NavBar-module__navLinks-tYulX a:hover,.nightbot-NavBar-module__navLinks-tYulX button:hover {
      color: var(--text-primary);
    }

@media (max-width: 768px) {
  .nightbot-NavBar-module__navLinks-tYulX {
    display: none;
  }
}

.nightbot-NavBar-module__navBarContainer-f0UqR {
  display: flex;
  justify-content: center;
  width: 100%;
  transition: background-color 0.3s ease-in-out;
}

.nightbot-NavBar-module__navBarInner-_2oKE {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
}

.nightbot-NavBar-module__scrolled-Isy_I {
  background-color: var(--background-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/NavBar.module.scss"],"names":[],"mappings":"AAAA;;EAEE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AASzB;;AAPE;IACE,4BAA4B;EAK9B;;AAHE;MACE,0BAA0B;IAC5B;;AAIJ;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".navBar,\n.actionButton {\n  flex: 1;\n}\n\n.actionButton {\n  display: flex;\n  justify-content: right;\n}\n\n.navLinks {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 32px;\n  justify-content: center;\n\n  a, button {\n    color: var(--text-secondary);\n\n    &:hover {\n      color: var(--text-primary);\n    }\n  }\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n  .navLinks {\n    display: none;\n  }\n}\n\n.navBarContainer {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  transition: background-color 0.3s ease-in-out;\n}\n\n.navBarInner {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n.scrolled {\n  background-color: var(--background-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navBar": `nightbot-NavBar-module__navBar-awooG`,
	"actionButton": `nightbot-NavBar-module__actionButton-cgQw8`,
	"navLinks": `nightbot-NavBar-module__navLinks-tYulX`,
	"navBarContainer": `nightbot-NavBar-module__navBarContainer-f0UqR`,
	"navBarInner": `nightbot-NavBar-module__navBarInner-_2oKE`,
	"scrolled": `nightbot-NavBar-module__scrolled-Isy_I`
};
export default ___CSS_LOADER_EXPORT___;
